<template>
  <div class="app-container">
    <el-card class="box-card">
      <folded-panel infoName="员工基本信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="formConfig"
            v-model="form"
            :showBtn="showBtn"
            ref="form"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="个人信息">
        <div slot="content">
          <dynamic-form
            labelWidth="110px"
            :formConfig="personConfig"
            v-model="form"
            :showBtn="showBtn"
          />
        </div>
      </folded-panel>
      <folded-panel infoName="薪资组成">
        <div slot="content">
          <edit-data-table
            :head="tableHead"
            :data.sync="tableData"
            :config="{ trigger: 'click', mode: 'cell' }"
            :editable="true"
            :showAdd="showAdd"
            height
          >
            <template #toolbar="{$index}">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="delPay($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="技能明细">
        <div slot="content">
          <edit-data-table
            ref="skillTable"
            :head="tableHead2"
            :data.sync="tableData2"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :showAdd="showAdd"
            height
          >
            <template #skillsTypeEntity="{row}">
              <span>{{row.skillsTypeEntity? row.skillsTypeEntity.name:''}}</span>
            </template>
            <template #skillsTypeEntityEdit="{row}">
              <data-box
                hostUrl="/bsSkillsType/findList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="headTypes"
                :multiple="false"
                v-model="row.skillsTypeEntity"
                @confirm="(val) => {row.skillsTyep = val.id}"
              ></data-box>
            </template>
            <!-- <template #skillsContentEntity="{row}">
              <span>{{row.skillsContentEntity? row.skillsContentEntity.name:''}}</span>
            </template> -->
            <!-- <template #skillsContentEntityEdit="{row}">
              <data-box
                hostUrl="/bsSkills/findList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="headContents"
                v-model="row.skillsContentEntity"
                @confirm="(val) => {row.skillsContent = val.id}"
                :multiple="false"
              ></data-box>
            </template> -->
            <template #skillsLevelEntity="{row}">
              <span>{{row.skillsLevelEntity ? row.skillsLevelEntity.name:''}}</span>
            </template>
            <template #skillsLevelEntityEdit="{row}">
              <data-box
                hostUrl="/bsProfessionalLevel/findList"
                :props="{label: 'name',value: 'id'}"
                v-model="row.skillsLevelEntity"
                :tableColumn="headLevels"
                :multiple="false"
                @confirm="(val) => {row.skillsLevel = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="delskill($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="证书明细">
        <div slot="content">
          <edit-data-table
            :head="tableHead3"
            :data.sync="tableData3"
            :config="{trigger: 'click', mode: 'cell',autoClearActive:false}"
            :editable="true"
            :showAdd="showAdd"
            height
          >
            <template #typeEntity="{row}">
              <span>{{row.typeEntity ? row.typeEntity.name:''}}</span>
            </template>
            <template #typeEntityEdit="{row}">
              <data-box
                hostUrl="/bsSkillsType/findList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="headCredentials"
                :multiple="false"
                v-model="row.typeEntity"
                @confirm="(val) => {row.type = val.id}"
              ></data-box>
            </template>
            <template #nameEntity="{row}">
              <span>{{row.nameEntity ? row.nameEntity.name:''}}</span>
            </template>
            <template #nameEntityEdit="{row}">
              <data-box
                hostUrl="/bsCredentials/findList"
                :props="{label: 'name',value: 'id'}"
                :tableColumn="headTypes"
                :multiple="false"
                v-model="row.nameEntity"
                @confirm="(val) => {row.name = val.id}"
              ></data-box>
            </template>
            <template #toolbar="{$index}">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="delCredntial($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <folded-panel infoName="劳动合同明细">
        <div slot="content">
          <edit-data-table
            :head="tableHead4"
            :data.sync="tableData4"
            :config="{trigger: 'click', mode: 'cell'}"
            :editable="true"
            :showAdd="showAdd"
            :border="true"
            height
          >
            <template #toolbar="{$index}">
              <el-button
                type="text"
                size="mini"
                icon="el-icon-delete"
                @click="delContract($index)"
              ></el-button>
            </template>
          </edit-data-table>
        </div>
      </folded-panel>
      <div class="button">
        <el-button class="btn-submit" :loading="loading" @click="submit" >提交</el-button>
        <el-button class="btn-cancel" :loading="loading" @click="cancel">取消</el-button>
      </div>
    </el-card>
  </div>
</template>
<script>
import FoldedPanel from "@/components/FoldedPanel";
import "@/components/EditDataTable";
import "@/components/dynamic-form";
import DataBox from "@/components/dynamic-form/dynamic-data-box";
import { addPerson, editPerson, personDetail, delContractDetail, delCredentials,delSalary, delSkill} from "@/api/basic";
import { parseTime } from "@/utils";
import CrudMixin from "@/mixins/CrudMixin";
import initDict from "@/mixin/initDict";
export default {
  name: "PersonForm",
  components: { FoldedPanel, DataBox},
  mixins: [CrudMixin,initDict],
  data() {
    return {
      id: "",
      showBtn: false,
      loading: false,
      form: {},
      form2: {},
      showAdd: true,
      formConfig: {
        formItemList: [
          // {
          //   type: "input",
          //   key: "clientId",
          //   label: "流水号",
          //   value: "",
          //   span: 8
          // },
          {
            label: "工号",
            key: "code",
            type: "input",
            span: 8,
            value: "",
            rules: {
              required: true,
              message: "工号不能为空",
              trigger: "change"
            }
          },
          {
            label: "姓名",
            key: "name",
            type: "input",
            span: 8,
            value: "",
            rules: {
              required: true,
              message: "姓名不能为空",
              trigger: "change"
            }
          },
          {
            label: "职级",
            key: "rank",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bsProfessionalLevel/findList",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              },
              {
                property: "skillsType",
                label: "技能类型"
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          {
            label: "岗位",
            key: "post",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/post/findList",
            tableColumn: [
              {
                property: "code",
                label: "编码"
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              },
              {
                property: "remark",
                label: "备注"
              }
            ],
            // extendParms: { queryFieldItem: "id,number,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            label: "部门",
            key: "department",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/dept/list",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,code,name" },
            multiple: false,
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          // {
          //   label: "汇报对象",
          //   key: "reportingTargets",
          //   type: "databox",
          //   span: 8,
          //   props: {
          //     label: "name",
          //     value: ""
          //   },
          //   url: "/dynamic/listData",
          //   tableColumn: [
          //     {
          //       property: "number",
          //       label: "编码",
          //       query: {
          //         type: "input"
          //       }
          //     },
          //     {
          //       property: "name",
          //       label: "名称",
          //       query: {
          //         type: "input"
          //       }
          //     }
          //   ],
          //   extendParms: { queryFieldItem: "id,number,name" },
          //   multiple: false
          // },
          {
            label: "绩效模式",
            key: "performanceModel",
            type: "databox",
            span: 8,
            props: {
              label: "name",
              value: ""
            },
            url: "/bsPerformanceMode/findList",
            tableColumn: [
              {
                property: "number",
                label: "编码",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
            // rules: {
            //   required: true,
            //   message: "不能为空",
            //   trigger: "change"
            // }
          },
          {
            label: "性别",
            key: "sex",
            type: "select",
            span: 8,
            options: [
              {
                value: "0",
                label: "男"
              },
              {
                value: "1",
                label: "女"
              }
            ]
          },
          {
            label: "联系电话",
            key: "telephone",
            type: "input",
            span: 8,
            value: "",
            rules: {
              required: true,
              message: "联系电话不能为空",
              trigger: "blur"
            }
          },
          {
            label: "出生年月",
            key: "birthday",
            type: "date",
            value: "",
            span: 8,
            valueFormat: "yyyy-MM-dd"
          },
          // {
          //   label: "户籍",
          //   key: "censusRegister",
          //   type: "input",
          //   span: 8,
          // },
        ]
      },
      personConfig: {
        formItemList: [
          {
            type: "input",
            key: "idNumber",
            label: "身份证号",
            value: "",
            span: 8,
            rules: [
              {
              validator(rule, value, callback) {
                const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
                if (reg.test(value)) {
                  callback();
                } else {
                  callback(new Error("请输入正确的身份证号！"));
                }
              },
              trigger: "blur"
            }
            ]
          },
          {
            label: "毕业学校",
            key: "school",
            type: "input",
            span: 8,
            value: ""
          },
          {
            label: "最高学历",
            key: "education",
            type: "select",
            span: 8,
            options: []
          },
          {
            label: "Mail",
            key: "mail",
            type: "input",
            span: 8,
            value: ""
          },
          {
            label: "常住地址",
            key: "address",
            type: "input",
            span: 8,
            value: ""
          },
          {
            label: "户籍地址",
            key: "censusRegisterAddress",
            type: "input",
            span: 8,
            value: ""
          },
          {
            label: "常用联系人",
            key: "frequentContacts",
            type: "input",
            span: 8,
            value: ""
          },
          {
            label: "常用联系人电话",
            key: "frequentContactsTel",
            type: "input",
            span: 8,
            value: ""
          },
          {
            type: "textarea",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入标题",
            span: 18
          }
        ]
      },
      tableHead: [
        {
          label: "薪资组成",
          prop: "salaryComposition",
          align: "left",
          editRender: {
            type: "default",
            name: "ElSelect",
            options: []
          }
        },
        {
          label: "金额",
          prop: "money",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData: [],
      tableHead2: [
        {
          label: "技能类型",
          prop: "skillsTypeEntity",
          editRender: { type: "default" }
        },
        // {
        //   label: "技能内容",
        //   prop: "skillsContent",
        //   editRender: {
        //     type: "default",
        //     name: "ElSelect",
        //     options: [] },
        // },
        {
          label: "技能等级",
          prop: "skillsLevelEntity",
          editRender: { type: "default" }
        },
        {
          label: "专职工作",
          prop: "fullTimeWork",
          formatter: this.fufullTimeWorkFormatter,
          editRender: {
            type: 'default', name: 'ElSelect', options: [
              {
                value: "Y",
                label: "是"
              },
              {
                value: "N",
                label: "否"
              },
            ]
          }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead3: [
        {
          label: "技能类型",
          prop: "typeEntity",
          editRender: { type: "default" }
        },
        {
          label: "证书名称",
          prop: "nameEntity",
          editRender: { type: "default" }
        },
        {
          label: "证书有效期",
          prop: "validityPeriod",
          formatter: this.formatter,
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "timestamp" }
          }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableHead4: [
        {
          label: "劳动合同起始日期",
          prop: "startTime",
          formatter: this.formatter,
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "timestamp" }
          }
        },
        {
          label: "劳动合同结束日期",
          prop: "endTime",
          formatter: this.formatter,
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "timestamp" }
          }
        },
        {
          label: "签约日期",
          prop: "signTime",
          formatter: this.formatter,
          editRender: {
            name: "ElDatePicker",
            props: { type: "date", valueFormat: "timestamp" }
          }
        },
        {
          label: "薪资说明",
          prop: "salary",
          editRender: { type: "default", name: "ElInput" }
        },
        {
          label: "备注",
          prop: "remark",
          editRender: { type: "default", name: "ElInput" }
        }
      ],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      obj: {},
      headTypes: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      headContents: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      headLevels: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      headCredentials: [
        { label: "编码", property: "code" },
        { label: "名称", property: "name", query: { type: "input" } },
        { label: "备注", property: "remark" }
      ],
      validateRefNames: ['form']
    };
  },
  created() {
    this.id = this.$route.query.id;
    if (this.id) {
      personDetail(this.id).then(res => {
        const form = res.data.bsPerson;
        form.rank = { id: form.rank, name: form.rankName };
        form.post = { id: form.post, name: form.postName };
        form.performanceModel = {
          id: form.performanceModel,
          name: form.performanceModelName
        };
        form.department = { id: form.department, name: form.departmentName };
        this.form = form;
        this.tableData = res.data.bssalarys;
        this.tableData2 = res.data.bsSkillsContents;
        this.tableData3 = res.data.bsCredentialsDetailed;
        this.tableData4 = res.data.bsContractDetaileds;
      });
    }
    // 学历
    this.getDict("education").then(res => {
       this.personConfig.formItemList[this.personConfig.formItemList.findIndex(ele => ele.key === 'education')].options = res.data;
    });
    // 技能内容
    // this.getDict("skill").then(res => {
    //   this.tableHead2[this.tableHead2.findIndex(ele => ele.prop === 'skill')].editRender.options = res.data;
    // });
    // 薪资组成
    this.getDict("salary").then(res => {
      this.tableHead[this.tableHead.findIndex(ele => ele.prop === 'salaryComposition')].editRender.options = res.data;
    });
  },
  methods: {
    fufullTimeWorkFormatter(val) {
      if (val === 'Y') {
        return '是'
      } else if (val === 'N') {
        return '否'
      } else {
        return ''
      }
    },
    formatter(val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    cancel() {
      this.$router.go(-1);
    },
     // 提交
    submit() {
      this.loading = true;
      this._validateForm(this.validateRefNames).then((res) => {
        this.pull(this.getFormData())
      }).catch(e => { this.loading = false; })
    },
    // 封装表单数据
    getFormData() {
       if (this.form.rank) {
        this.form.rankName = this.form.rank.name;
        this.form.rank = this.form.rank.id;
      }
      if (this.form.post) {
        this.form.postName = this.form.post.name;
        this.form.post = this.form.post.id;
      }
      if (this.form.department) {
        this.form.departmentName = this.form.department.name;
        this.form.department = this.form.department.id;
      }
      if (this.form.performanceModel) {
        this.form.performanceModelName = this.form.performanceModel.name;
        this.form.performanceModel = this.form.performanceModel.id;
      }
      this.obj.bsPerson = this.form;
      this.obj.bssalarys = this.tableData;
      this.obj.bsSkillsContents = this.tableData2;
      this.obj.bsCredentialsDetailed = this.tableData3;
      this.obj.bsContractDetaileds = this.tableData4;
      return this.obj;
    },
    pull(obj) {
        this.loading = false;
        if (this.id) {
        editPerson(obj).then(res => {
            this.loading = false;
          if (res.code === 200) {
            this.$notify({
              title: "操作成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        }).catch(e => { this.loading = false; });
      } else {
        addPerson(obj).then(res => {
            this.loading = false;
          if (res.code === 200) {
            this.$notify({
              title: "操作成功",
              type: "success",
              duration: 2500
            });
            this.$router.go(-1);
          }
        }).catch(e => { this.loading = false; });
      }
    },
    // 删除某一行数据
    delPay(index) {
      if (this.tableData[index].id) {
        delSalary(this.tableData[index].id).then(res => {
          console.log(res);
        });
        this.tableData.splice(index, 1);
      } else {
        this.tableData.splice(index, 1);
      }
    },
    delskill(index) {
      if (this.tableData2[index].id) {
        delSkill(this.tableData2[index].id);
        this.tableData2.splice(index, 1);
      } else {
        this.tableData2.splice(index, 1);
      }
    },
    delCredntial(index) {
      if (this.tableData3[index].id) {
        delCredentials(this.tableData3[index].id);
        this.tableData3.splice(index, 1);
      } else {
        this.tableData3.splice(index, 1);
      }
    },
    delContract(index) {
      if (this.tableData4[index].id) {
        delContractDetail(this.tableData4[index].id);
        this.tableData4.splice(index, 1);
      } else {
        this.tableData4.splice(index, 1);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.button {
  padding-top: 20px;
  text-align: right;
  .btn-submit {
    width: 80px;
    height: 38px;
    background: #1369a8;
    color: white;
  }
  .btn-cancel {
    width: 80px;
    height: 38px;
    background: #fff;
  }
}
</style>
